import React from "react";

const PencilSVG = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="12.093"
      height="12.093"
      viewBox="0 0 12.093 12.093"
    >
      <path
        id="pencil-alt-solid"
        d="M11.784,3.43,10.695,4.519a.284.284,0,0,1-.4,0L7.671,1.9a.284.284,0,0,1,0-.4L8.76.406a1.136,1.136,0,0,1,1.6,0l1.42,1.42A1.132,1.132,0,0,1,11.784,3.43Zm-5.048-1-6.2,6.2-.5,2.87a.568.568,0,0,0,.657.657l2.87-.5,6.2-6.2a.284.284,0,0,0,0-.4L7.14,2.431a.287.287,0,0,0-.4,0ZM2.954,8.1a.329.329,0,0,1,0-.468L6.592,4a.331.331,0,0,1,.468.468L3.422,8.1a.329.329,0,0,1-.468,0ZM2.1,10.088H3.235v.857l-1.524.267-.735-.735.267-1.524H2.1Z"
        transform="translate(-0.024 -0.075)"
        fill="#e39d00"
      />
    </svg>
  );
};

export default PencilSVG;
